import api from "../api";
/**
 * 首页查询游记列表
 * @param {*} params
 * @param {*} url
 */
const searchTravelList = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "info/getNewestList",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });
/**
 * 首页点击某一数据获取游记详情
 * @param {*} params
 * @param {*} url
 */
const trevelNotesdetail = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "scenic/getTravelNoteInfoDetail",
    data: params,
    loading: true,
    token: false,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });
const trevelNotesDetailOld = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "info/getTravelNoteInfoDetail",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });
/**
 * 获取自驾玩法属性
 * @param {*} params
 * @param {*} url
 */
const DataTypeList = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "code/queryTypeCode",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });
/**
 * 想去玩儿列表
 * @param {*} params
 * @param {*} url
 */
const WantList = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "wantgo/queryWantGo",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: true
    }
  });
/**
 * 游记列表
 * @param {*} params
 * @param {*} url
 */
const TravelList = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "info/queryInfo",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });

/**
 * 首页热度游记列表(用户未登录游记推荐)
 * @param {*} params
 * @param {*} url
 */
const hotTravelList = (params, url) =>
  api.post({
    service: "TRAVEL_SEARCH",
    url: "recommend/getHotList",
    data: params,
    loading: false,
    token: false
  });

/**
 * 首页推荐游记列表(用户登录推荐游记)
 * @param {*} params
 * @param {*} url
 */
const recommendTravelList = (params, url) =>
  api.post({
    service: "TRAVEL_SEARCH",
    url: "recommend/getRecommendList",
    data: params,
    loading: false,
    token: true
  });

/**
 * 首页推荐列表
 * @param {*} params
 * @param {*} url
 */
const recommendTravelNoteList = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "info/getRecommendList",
    data: params,
    loading: false,
    token: true
  });

/**
 * 进查看页面的验证是否添加想去玩儿
 * @param {*} params
 * @param {*} url
 */
const CheckWantgo = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "wantgo/checkAndGetNum",
    data: params,
    // loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });
/**
 * 添加想去玩儿
 * @param {*} params
 * @param {*} url
 */
const AddWantGo = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "wantgo/addWantGo",
    data: params,
    // loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: true
    }
  });
/**
 * 删除想去玩儿
 * @param {*} params
 * @param {*} url
 */
const DeleteWantGo = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "wantgo/deleteWantGo",
    urlItem: "1/",
    data: params,
    token: true,
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      authentication: true
    }
  });
/**
 * 查询个人信息接口
 * @param {*} params
 * @param {*} url
 */
const userdetail = (params, url) =>
  api.post({
    service: "USER_AUTH_USERINFORMATION",
    url: "web/user/getUserdetail",
    data: params,
    loading: true,
    token: false,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });
/**
 * 更新个人信息
 * @param {*} params
 * @param {*} url
 */
const userModify = (params, url) =>
  api.post({
    service: "USER_AUTH_USERINFORMATION",
    url: "web/user/modify",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: true
    }
  });
/**
 * 获取城市code
 * @param {*} params
 * @param {*} url
 */
const cityListCode = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "code/queryArea",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });
/**
 * 删除游记
 * @param {*} params
 * @param {*} url
 */
const deleteTravel = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "task/delete",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: true
    }
  });

/**
 * 添加评论
 * @param {*} params
 * @param {*} url
 */
const saveComment = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "info/saveComment",
    data: params,
    loading: true,
    token: true,
    urlItem: "1/",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      authentication: true
    }
  });

/**
 * 检索评论
 * @param {*} params
 * @param {*} url
 */
const queryComment = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "comment/queryComment",
    data: params,
    loading: params.loadingFlase ? false : true,
    //如果用户提供了loadingFalse则禁止loading
    token: false,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });

/**
 * 点赞评论
 * @param {*} params
 * @param {*} url
 */
const adoptComment = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "comment/adoptComment",
    data: params,
    loading: false,
    token: false,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: true
    }
  });

  /**
 * 回复评论
 * @param {*} params
 * @param {*} url
 */
const replyComment = (params, url) =>
api.post({
  service: "USER_AUTH_SERVICEINTERFACE",
  url: "comment/replyComment",
  data: params,
  loading: false,
  token: false,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    authentication: true
  }
});

/**
 * 获取我的评论
 * @param {*} params
 * @param {*} url
 */
const getOwnComment = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "comment/queryOwnComment",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: true
    }
  });

/**
 * 删除评论
 * @param {*} params
 * @param {*} url
 */
const removeComment = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "comment/removeComment",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });

/**
 * 过滤评论敏感词（前端暂时不用）
 * @param {*} params
 * @param {*} url
 */
const filterComment = (params, url) =>
  api.post({
    service: "WORD_FILTER_SERVICEINTERFACE",
    url: "analyze/sensitive",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });

/**
 * 查询消息通知列表
 * @param {*} params
 * @param {*} url
 */
const pushMessageList = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "notice/queryNoticeList",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });

/**
 * 增加一条消息(注册成功)
 * @param {*} params
 * @param {*} url
 */
const pushMessageAdd = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "notice/addNotice",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });

/**
 * 删除一条消息
 * @param {*} params
 * @param {*} url
 */
const pushMessageDelete = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "notice/modifyNotice",
    data: params,
    loading: true,
    token: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      authentication: false
    }
  });

  /**
 * 保存用户反馈
 * @param {*} params
 * @param {*} url
 */
const saveFeedback = (params, url) =>
api.post({
  service: "USER_AUTH_SERVICEINTERFACE",
  url: "feedback/saveFeedback",
  data: params,
  loading: true,
  token: true,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    authentication: false
  }
});

export {
  searchTravelList,
  trevelNotesdetail,
  trevelNotesDetailOld,
  DataTypeList,
  WantList,
  TravelList,
  hotTravelList,
  recommendTravelList,
  CheckWantgo,
  AddWantGo,
  DeleteWantGo,
  userdetail,
  userModify,
  cityListCode,
  deleteTravel,
  saveComment,
  queryComment,
  adoptComment,
  replyComment,
  getOwnComment,
  removeComment,
  filterComment,
  recommendTravelNoteList,
  pushMessageList,
  pushMessageAdd,
  pushMessageDelete,
  saveFeedback
};
